import { Container, Text } from './styles'

const SimpleSnackbar = ({ text }: { text: string }) => (
  <Container>
    <Text>{text}</Text>
  </Container>
)

export default SimpleSnackbar
